import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import NeshanMap from './NeshanMap';

function Map(props) {
  const { lat1, lng1, mapLoad1,mapHandler,name } = props;
  const [myNeshan, setMyNeshan] = useState(false);
  const [myLeaflet, setMyLeaflet] = useState(false);
  const [markers, setMarkers] = useState([]);

  useEffect(() => {
    if (typeof (myNeshan) == "object") {
      myNeshan.invalidateSize();
      if (markers.length > 0) {
        for (var i = 0; i < markers.length; i++) {
          myNeshan.removeLayer(markers[i]);
        }
      }
      // when search address in searchbox and show on map
      myNeshan.panTo(new myLeaflet.LatLng(lat1, lng1));

      var marker = new myLeaflet.marker(new myLeaflet.LatLng(lat1, lng1)).addTo(myNeshan);

      myNeshan.setZoom(12);

      let m = [];
      m.push(marker)

      setMarkers(m)
    }
  }, [props.lng1, props.mapLoad1])

  return (
    <Container className='p-0 m-0'>
      <NeshanMap
        stch={props.loadMap1}
        options={{
          key: "web.jZsJ1ZRvwmhzt0O9kjkihz3m9txx4JomfuMdMGju",
          maptype: "dreamy",
          poi: true,
          traffic: false,
          center: [props.lat1, props.lng1],
          zoom: 13,
        }}

           // when search address on map and show in searchbox
        onInit={(L, myMap) => {
          var theMarker = L.marker([props.lat1, props.lng1]).addTo(myMap);

          //add or remove marker on map
          myMap.on("click", function (e) {

            var lat = (e.latlng.lat);
            var lng = (e.latlng.lng);
             
            mapHandler(lat,lng,name)
           // myMap.removeLayer(marker);
            if (theMarker !== undefined) {
              myMap.removeLayer(theMarker);
            };

            theMarker = L.marker([lat, lng]).addTo(myMap)

          });
          let m = [];
         // m.push(marker)
          setMarkers(m)

          setMyNeshan(myMap);
          setMyLeaflet(L);
        }}
        style={{ width: "100%", heigth: "200px" }}
      />
    </Container>
  );
}

export default Map;